// extracted by mini-css-extract-plugin
export default {"navIcon":"style_navIcon__dGVyb","open":"style_open__peZQp"};